var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.212 12.935L16.8787 4.76837C16.376 4.32851 15.6253 4.32851 15.1226 4.76837L5.78931 12.935C5.49996 13.1882 5.33398 13.554 5.33398 13.9385V25.3335C5.33398 26.0698 5.93094 26.6668 6.66732 26.6668H12.0007C12.737 26.6668 13.334 26.0698 13.334 25.3335V20.0001C13.334 19.2637 13.9309 18.6668 14.6673 18.6668H17.334C18.0704 18.6668 18.6673 19.2637 18.6673 20.0001V25.3335C18.6673 26.0698 19.2643 26.6668 20.0007 26.6668H25.334C26.0704 26.6668 26.6673 26.0698 26.6673 25.3335V13.9385C26.6673 13.554 26.5013 13.1882 26.212 12.935Z",
    fill: "#CCE5FF",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.32112584983d782a4a91d86e8fddb7e4.svg";
export { ForwardRef as ReactComponent };